import { useState } from "react";
import "./editorialForms.css";

export default function EsportsForm({ data, onChange }) {
  const [teamInput, setTeamInput] = useState({ name: "", score: "" });

  const games = [
    "League of Legends",
    "Counter-Strike 2",
    "Valorant",
    "Dota 2",
    "Fortnite",
    "PUBG",
    "Overwatch 2",
    "Rocket League",
    "Rainbow Six Siege",
    "Apex Legends",
    "FIFA",
    "Call of Duty",
    "Free Fire",
  ];

  const stages = [
    "Fase de Grupos",
    "Oitavas de Final",
    "Quartas de Final",
    "Semifinal",
    "Final",
    "Grande Final",
    "Qualificatorias",
    "Playoffs",
  ];

  const handleAddTeam = () => {
    if (teamInput.name.trim()) {
      const currentTeams = data?.teams || [];
      onChange({
        ...data,
        teams: [
          ...currentTeams,
          {
            name: teamInput.name.trim(),
            score: parseInt(teamInput.score) || 0,
            logo: "",
          },
        ],
      });
      setTeamInput({ name: "", score: "" });
    }
  };

  const handleRemoveTeam = (index) => {
    const currentTeams = data?.teams || [];
    onChange({
      ...data,
      teams: currentTeams.filter((_, i) => i !== index),
    });
  };

  const handleTeamScore = (index, score) => {
    const currentTeams = [...(data?.teams || [])];
    currentTeams[index] = { ...currentTeams[index], score: parseInt(score) || 0 };
    onChange({ ...data, teams: currentTeams });
  };

  return (
    <div className="editorial_form esports_form">
      <div className="editorial_form_section">
        <label>
          Nome do Torneio <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: CBLOL 2024"
          value={data?.tournament || ""}
          onChange={(e) => onChange({ ...data, tournament: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Jogo <span className="required">*</span>
        </label>
        <select
          value={data?.game || ""}
          onChange={(e) => onChange({ ...data, game: e.target.value })}
        >
          <option value="">Selecione o jogo</option>
          {games.map((game) => (
            <option key={game} value={game}>
              {game}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>
          Times
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddTeam}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row">
          <input
            type="text"
            placeholder="Nome do time"
            value={teamInput.name}
            onChange={(e) =>
              setTeamInput({ ...teamInput, name: e.target.value })
            }
          />
          <input
            type="number"
            placeholder="Placar"
            value={teamInput.score}
            onChange={(e) =>
              setTeamInput({ ...teamInput, score: e.target.value })
            }
            style={{ maxWidth: "80px" }}
          />
        </div>
        {(data?.teams || []).map((team, i) => (
          <div key={i} className="variant_row">
            <input type="text" value={team.name} disabled />
            <input
              type="number"
              value={team.score}
              onChange={(e) => handleTeamScore(i, e.target.value)}
              style={{ maxWidth: "80px" }}
            />
            <button
              type="button"
              className="remove_variant_btn"
              onClick={() => handleRemoveTeam(i)}
            >
              x
            </button>
          </div>
        ))}
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Fase</label>
          <select
            value={data?.stage || ""}
            onChange={(e) => onChange({ ...data, stage: e.target.value })}
          >
            <option value="">Selecione</option>
            {stages.map((stage) => (
              <option key={stage} value={stage}>
                {stage}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Data da Partida</label>
          <input
            type="datetime-local"
            value={data?.matchDate || ""}
            onChange={(e) => onChange({ ...data, matchDate: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Premiacao (USD)</label>
        <input
          type="number"
          placeholder="Ex: 100000"
          value={data?.prizePool || ""}
          onChange={(e) =>
            onChange({ ...data, prizePool: parseInt(e.target.value) || 0 })
          }
        />
      </div>

      <div className="editorial_form_section">
        <label>Link da Transmissao</label>
        <input
          type="url"
          placeholder="https://twitch.tv/..."
          value={data?.streamUrl || ""}
          onChange={(e) => onChange({ ...data, streamUrl: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isLive"
            checked={data?.isLive || false}
            onChange={(e) => onChange({ ...data, isLive: e.target.checked })}
          />
          <label htmlFor="isLive" className="breaking_label">
            AO VIVO AGORA
          </label>
        </div>
      </div>

      <div className="editorial_form_tip esports_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-4v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" />
        </svg>
        <span>
          Publique resultados de partidas, torneios e campeonatos de e-sports.
          Adicione os times participantes e o placar.
        </span>
      </div>
    </div>
  );
}
